/**
 * Récupère l'URL de redirection sauvegardée et la supprime du sessionStorage
 * @returns L'URL de redirection ou "/" par défaut
 */
export const getRedirectUrl = (): string => {
  const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
  if (redirectUrl) {
    sessionStorage.removeItem("redirectAfterLogin");
    return redirectUrl;
  }
  return "/";
};

/**
 * Sauvegarde l'URL actuelle pour redirection après connexion
 * @param pathname - Le chemin actuel
 * @param search - Les paramètres de recherche
 */
export const saveRedirectUrl = (
  pathname: string,
  search: string = ""
): void => {
  sessionStorage.setItem("redirectAfterLogin", pathname + search);
};
